<template>
  <div class="form-btn-bar">
    <div class="form-btn-inner">
      <v-btn
        v-if="this.WizardBool"
        class="fbtn fbtn-primary"
        @click="onNextPressed"
      >
        <v-icon size="16" class="mr-1">mdi-arrow-right</v-icon>
        Next
      </v-btn>
      <v-btn
        v-if="this.EditBool"
        class="fbtn fbtn-secondary"
        @click="onNewPressed"
      >
        <v-icon size="16" class="mr-1">mdi-plus</v-icon>
        {{ $t('button.new') }}
      </v-btn>
      <v-btn
        v-if="!confirmAction"
        class="fbtn fbtn-success"
        @click="onSavePressed"
      >
        <v-icon size="16" class="mr-1">mdi-check</v-icon>
        {{ $t('button.save') }}
      </v-btn>
      <v-btn
        v-if="confirmAction"
        class="fbtn fbtn-success"
        @click="onYesPressed"
      >
        <v-icon size="16" class="mr-1">mdi-check</v-icon>
        {{ $t('claimmessagemobile.yes') }}
      </v-btn>
      <v-btn
        v-if="this.EditBool"
        class="fbtn fbtn-danger"
        @click="onDeletePressed"
      >
        <v-icon size="16" class="mr-1">mdi-delete</v-icon>
        {{ $t('button.delete') }}
      </v-btn>
      <v-btn
        v-if="!hideCancel"
        class="fbtn fbtn-cancel"
        @click="onCancelPressed"
      >
        <v-icon size="16" class="mr-1">mdi-close</v-icon>
        {{ $t('button.cancel') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        EditBool: Boolean,
        WizardBool: Boolean,
        confirmAction: Boolean,
        hideCancel: Boolean
    },

    methods: {
        onNextPressed() {
            this.$emit('NextPressed');
        },

        onNewPressed() {
            this.$emit('NewPressed');
        },

        onSavePressed() {
            this.$emit('SavePressed');
        },

        onYesPressed() {
            this.$emit('YesPressed');
        },

        onDeletePressed() {
            this.$emit('DeletePressed');
        },

        onCancelPressed() {
            this.$emit('CancelPressed');
        }
    }
}
</script>

<style scoped>
.form-btn-bar {
  background: #F8FAFF;
  border-top: 1px solid #E8EDF5;
  padding: 16px 20px;
  border-radius: 0 0 16px 16px;
  margin-top: 8px;
  margin-left: -12px;
  margin-right: -12px;
}

.form-btn-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.fbtn {
  min-width: 100px !important;
  height: 38px !important;
  border-radius: 8px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  box-shadow: none !important;
  transition: all 0.15s !important;
}

.fbtn-primary {
  background: linear-gradient(135deg, #4F6BFF, #7C3AFF) !important;
  color: #fff !important;
  box-shadow: 0 4px 10px rgba(79,107,255,0.25) !important;
}
.fbtn-primary:hover {
  box-shadow: 0 6px 14px rgba(79,107,255,0.35) !important;
  transform: translateY(-1px) !important;
}

.fbtn-secondary {
  background: #EEF2FF !important;
  color: #4F6BFF !important;
}
.fbtn-secondary:hover {
  background: #4F6BFF !important;
  color: #fff !important;
}

.fbtn-success {
  background: #059669 !important;
  color: #fff !important;
  box-shadow: 0 4px 10px rgba(5,150,105,0.2) !important;
}
.fbtn-success:hover {
  background: #047857 !important;
  box-shadow: 0 6px 14px rgba(5,150,105,0.3) !important;
  transform: translateY(-1px) !important;
}

.fbtn-danger {
  background: #FEE2E2 !important;
  color: #DC2626 !important;
}
.fbtn-danger:hover {
  background: #DC2626 !important;
  color: #fff !important;
}

.fbtn-cancel {
  background: #F1F5F9 !important;
  color: #64748B !important;
}
.fbtn-cancel:hover {
  background: #E2E8F0 !important;
  color: #334155 !important;
}
</style>